import {
    MODAL_VENDOR_KEY_VALUE,
    MODAL_VENDOR_INPUT_EMPCODE,
    MODAL_VENDOR_INPUT_EMPNAME,
    MODAL_VENDOR_SET_RESULT
} 
from './actionTypes';

export function setKeyValueAction(table, vendorCode, vendorName) {
  
    return function (dispatch) {

        dispatch({
            type: MODAL_VENDOR_KEY_VALUE,
            table: table,
            vendorCode: vendorCode,
            vendorName: vendorName
        })

    }
}

export function setInputAction(input_name, input_value) {
  
    return function (dispatch) {

        if(input_name == "q_vendorCode"){
            dispatch({
                type: MODAL_VENDOR_INPUT_EMPCODE,
                value: input_value
            })
    
        }else if(input_name == "q_vendorName"){
            dispatch({
                type: MODAL_VENDOR_INPUT_EMPNAME,
                value: input_value
            })
        }else if(input_name == "result_vendors"){
            dispatch({
                type: MODAL_VENDOR_SET_RESULT,
                value: input_value
            })
        }else{

        }
       
    }
}


export function clearModalAction() {
  
    return function (dispatch) {

        dispatch({
            type: MODAL_VENDOR_KEY_VALUE,
            table: null,
            vendorCode: null,
            vendorName: null
        })

        dispatch({
            type: MODAL_VENDOR_INPUT_EMPCODE,
            value: null
        })

        dispatch({
            type: MODAL_VENDOR_INPUT_EMPNAME,
            value: null
        })

        dispatch({
            type: MODAL_VENDOR_SET_RESULT,
            value: null
        })
       
    }
}